import React, { useState, useEffect, useContext } from "react";
import { Card, Table, Button, Form} from "react-bootstrap";
import NotyfContext from "../contexts/NotyfContext";
import { X, Check, Edit2, Trash2} from "react-feather";
import Select from "react-select";

import { useTable, useSortBy, useFilters} from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";

import authenticatedFetch from "../utils/fetch"
import { caseInsensitiveSort } from "./reactTableUtils";


const AreaOfExpertiseSelect = ({ providerId, handleAreaOfExpertiseChanged, selectedAreaOfExpertise}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
  
    useEffect(() => {
        authenticatedFetch({
            path: "areaofexpertise/all/" + providerId,
                successHandler: function(result) {
                setIsLoaded(true);
                setData(result);
            },
            errorHandler: function(error) {
                setIsLoaded(true);
                setError(error);
            }
        });
    }, [])
  
    const options = data.map((aoe) => {
        return {value: aoe.id, label: aoe.description};
    });

    if (!isLoaded)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
        return (
            <div style={{width: "300px"}}>
                <Select
                options={options}
                onChange={(selectedAreaOfExpertise) => {
                    handleAreaOfExpertiseChanged(selectedAreaOfExpertise);
                }}
                value={[selectedAreaOfExpertise]}
                placeholder="Select..."
                isMulti={false}
                isClearable={true}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                  ...theme.colors,
                    primary50: '#DEF2F1',
                    primary25: '#DEF2F1',
                    primary: '#3AAFA9',
                  },
                })}
                />
            </div>
        )
    }
}

const ProviderAreasOfExpertiseAgeRangeTable = ({ providerId, list, ageLowerBound, ageUpperBound, isLoaded, refreshList, canEdit }) => {
  const [editing, setEditing] = useState(false);
  const [localAgeLowerBound, setLocalAgeLowerBound] = useState(ageLowerBound);
  const [localAgeUpperBound, setLocalAgeUpperBound] = useState(ageUpperBound);
  
  const notyf = useContext(NotyfContext);

  useEffect(() => {
    setLocalAgeLowerBound(ageLowerBound);
    setLocalAgeUpperBound(ageUpperBound);
  }, [ageLowerBound, ageUpperBound]);

  function handleEditClicked(e) {
    e.preventDefault();
    setEditing(true);
  }

  function cancelEdit(e) {
    e.preventDefault();
    setEditing(false);
    setLocalAgeLowerBound(ageLowerBound);
    setLocalAgeUpperBound(ageUpperBound);
  }

  function saveEdit(e) {
    e.preventDefault();

    if (localAgeLowerBound && (parseInt(localAgeLowerBound) < 0 || parseInt(localAgeLowerBound) > 120))
    {
      alert("Please enter a valid minimum age (0-120)");
      return;
    }
    if (localAgeUpperBound && (parseInt(localAgeUpperBound) < 0 || parseInt(localAgeUpperBound) > 120))
    {
      alert("Please enter a valid maximum age (0-120)");
      return;
    }
    if (localAgeLowerBound && localAgeUpperBound && parseInt(localAgeLowerBound) > parseInt(localAgeUpperBound))
    {
      alert("Please enter a valid age range");
      return;
    }

    if (ageLowerBound !== localAgeLowerBound || ageUpperBound !== localAgeUpperBound)
    {
      if (list && list.length > 0)
      {
        var lowPrevDisplay = ageLowerBound ? ageLowerBound : "(any)";
        var highPrevDisplay = ageUpperBound ? ageUpperBound : "(any)";
        var lowNewDisplay = localAgeLowerBound ? localAgeLowerBound : "(any)";
        var highNewDisplay = localAgeUpperBound ? localAgeUpperBound : "(any)";
        if (!window.confirm("This will update any areas of expertise below that previously had an age range of " + lowPrevDisplay + " - " + highPrevDisplay + " to a range of " + lowNewDisplay +" - " + highNewDisplay + ". Are you sure you want to continue?"))
        {
          return;
        }
      }

      setEditing(false);

      authenticatedFetch({
        method: "PUT",
        requestData: {providerId: parseInt(providerId), ageLowerBound: localAgeLowerBound, ageUpperBound: localAgeUpperBound},
        path: "areaofexpertise/provider/" + providerId,
        successHandler: function(result) {
          refreshList();
          notyf.open({type: "success", message: "Updated!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
        },
        errorHandler: function() {
          setEditing(true);
          setLocalAgeLowerBound(ageLowerBound);
          setLocalAgeUpperBound(ageUpperBound);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
    }
    else
    {
      setEditing(false);
    }
  }

  const handleAgeLowerBoundChanged = (e) => {
    e.preventDefault();
    setLocalAgeLowerBound(e.target.value);
  }
  const handleAgeUpperBoundChanged = (e) => {
    e.preventDefault();
    setLocalAgeUpperBound(e.target.value);
  }

  if (!isLoaded)
  {
    return (
      <Table className="table-sm" striped bordered hover>
        <thead>
        </thead>
        <tbody>
          <tr>
            <td colSpan={3}>Loading...</td>
          </tr>
        </tbody>
      </Table>
    );
  }

  return (
    <Table className="table-sm" striped hover>
    <thead>
    </thead>
    <tbody>
      <tr>
      <td>Age Range Treated</td>
      <>
      {editing ?
      <td>
        <Form.Control size="sm" type="number" maxLength={3} value={localAgeLowerBound} onChange={(e) => {handleAgeLowerBoundChanged(e)}} />
      </td>
      :
      <td>
        {localAgeLowerBound}
      </td>
      }
      <td>-</td>
      {editing ?
      <td>
        <Form.Control size="sm" type="number" maxLength={3} value={localAgeUpperBound} onChange={(e) => {handleAgeUpperBoundChanged(e)}} />
      </td>
      :
      <td>
        {localAgeUpperBound}
      </td>
      }
      <td style={{width: '70px'}}>
        { canEdit?
          <>
          {editing ? 
          <>
            <X style={{'height': '16px', 'width': '16px'}} cursor="pointer" onClick={(e) => {cancelEdit(e)}} />
            &nbsp;<Check style={{'height': '16px', 'width': '16px'}} cursor="pointer" onClick={(e) => {saveEdit(e)}} className="text-success"/>
          </>
          :
          <>
            <Edit2 style={{'height': '12px', 'width': '12px'}} cursor="pointer" onClick={(e) => {handleEditClicked(e)}}/>
          </>
          }
          </>
          : <>&nbsp;</>
        }
      </td>
    </>
    </tr>
    </tbody>
    </Table>
  )
}


const ProviderAreaOfExpertise = ({ id, providerId, areaOfExpertiseId, description, ageLowerBound, ageUpperBound, refreshList, canEdit, onCancelEdit, startInEditMode=false }) => {
  const [editing, setEditing] = useState(startInEditMode);
  const [localAreaOfExpertiseId, setLocalAreaOfExpertiseId] = useState(areaOfExpertiseId);
  const [localDescription, setLocalDescription] = useState(description);
  const [localAgeLowerBound, setLocalAgeLowerBound] = useState(ageLowerBound);
  const [localAgeUpperBound, setLocalAgeUpperBound] = useState(ageUpperBound);
  
  const notyf = useContext(NotyfContext);

  function handleDeleteClicked(e) {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete this area of expertise?"))
    {
      authenticatedFetch({
        method: "DELETE",
        path: "areaofexpertise/" + providerId + "/" + id,
        successHandler: function(result) {
          refreshList();
        },
        errorHandler: function(error) {
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
    }
  }

  function handleEditClicked(e) {
    e.preventDefault();
    setEditing(true);
  }

  function cancelEdit(e) {
    e.preventDefault();
    setEditing(false);
    setLocalAreaOfExpertiseId(areaOfExpertiseId);
    setLocalDescription(description);
    setLocalAgeLowerBound(ageLowerBound);
    setLocalAgeUpperBound(ageUpperBound);

    if (onCancelEdit)
    {
      onCancelEdit();
    }
  }

  function saveEdit(e) {
    e.preventDefault();
    if (localAreaOfExpertiseId <= 0 || localDescription.length === 0)
    {
      alert("Please select a description");
      return;
    }

    if (localAgeLowerBound && (parseInt(localAgeLowerBound) < 0 || parseInt(localAgeLowerBound) > 120))
    {
      alert("Please enter a valid minimum age (0-120)");
      return;
    }
    if (localAgeUpperBound && (parseInt(localAgeUpperBound) < 0 || parseInt(localAgeUpperBound) > 120))
    {
      alert("Please enter a valid maximum age (0-120)");
      return;
    }
    if (localAgeLowerBound && localAgeUpperBound && parseInt(localAgeLowerBound) > parseInt(localAgeUpperBound))
    {
      alert("Please enter a valid age range");
      return;
    }

    setEditing(false);

    if (areaOfExpertiseId !== localAreaOfExpertiseId || ageLowerBound !== localAgeLowerBound || ageUpperBound !== localAgeUpperBound)
    {
      authenticatedFetch({
        method: id ? "PUT" : "POST",
        requestData: {providerId: parseInt(providerId), areaOfExpertiseId: localAreaOfExpertiseId, ageLowerBound: localAgeLowerBound, ageUpperBound: localAgeUpperBound},
        path: id ? "areaofexpertise/" + id  : "areaofexpertise",
        successHandler: function(result) {
          refreshList();
          notyf.open({type: "success", message: id ? "Updated!" : "Saved!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
        },
        errorHandler: function() {
          setEditing(true);
          setLocalAreaOfExpertiseId(areaOfExpertiseId);
          setLocalDescription(description);
          setLocalAgeLowerBound(ageLowerBound);
          setLocalAgeUpperBound(ageUpperBound);
          notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
        }
      });
    }
  }

  const handleAreaOfExpertiseChanged = (areaOfExpertiseDict) => {
    // Comes as a dict when not set to multi

    if (areaOfExpertiseDict == null)
    {
      setLocalAreaOfExpertiseId(0);
      setLocalDescription("");
    }
    else
    {
      setLocalAreaOfExpertiseId(areaOfExpertiseDict.value);
      setLocalDescription(areaOfExpertiseDict.label);
    }
  }

  const handleAgeLowerBoundChanged = (e) => {
    e.preventDefault();
    setLocalAgeLowerBound(e.target.value);
  }
  const handleAgeUpperBoundChanged = (e) => {
    e.preventDefault();
    setLocalAgeUpperBound(e.target.value);
  }

  var selectedAreaOfExpertiseTransformed = null;
  if (localAreaOfExpertiseId && localAreaOfExpertiseId > 0 && localDescription && localDescription.length > 0)
  {
    selectedAreaOfExpertiseTransformed = {value: localAreaOfExpertiseId, label: localDescription};
  }

  return (
    <>
    {editing ?
    <td style={{width: '350px'}}>
      <AreaOfExpertiseSelect providerId={providerId} handleAreaOfExpertiseChanged={handleAreaOfExpertiseChanged} selectedAreaOfExpertise={selectedAreaOfExpertiseTransformed}/>
    </td>
    :
    <td style={{width: '350px'}}>
      {localDescription}
    </td>
    }
    {editing ?
    <td>
      <Form.Control size="sm" type="number" maxLength={3} value={localAgeLowerBound} onChange={(e) => {handleAgeLowerBoundChanged(e)}} />
    </td>
    :
    <td>
      {localAgeLowerBound}
    </td>
    }
    {editing ?
    <td>
      <Form.Control size="sm" type="number" maxLength={3} value={localAgeUpperBound} onChange={(e) => {handleAgeUpperBoundChanged(e)}} />
    </td>
    :
    <td>
      {localAgeUpperBound}
    </td>
    }
    <td style={{width: '70px'}}>
      { canEdit?
        <>
        {editing ? 
        <>
          <X style={{'height': '16px', 'width': '16px'}} cursor="pointer" onClick={(e) => {cancelEdit(e)}} />
          &nbsp;<Check style={{'height': '16px', 'width': '16px'}} cursor="pointer" onClick={(e) => {saveEdit(e)}} className="text-success"/>
        </>
        :
        <>
          <Edit2 style={{'height': '12px', 'width': '12px'}} cursor="pointer" onClick={(e) => {handleEditClicked(e)}}/>&nbsp;&nbsp;
          <Trash2 style={{'height': '12px', 'width': '12px'}} cursor="pointer" onClick={(e) => {handleDeleteClicked(e)}}/>
        </>
        }
        </>
        : <>&nbsp;</>
      }
    </td>
  </>
  )
}


const AreasOfExpertiseTable = ({providerId, providerAgeLowerBound, providerAgeUpperBound, addingNew, onCancelAddNew, list, isLoaded, error, canEdit, refreshList}) => {
  const data = list;

  const columns = React.useMemo(
    () => [
      {
        accessor: "id",
        key: "id",
      },
      {
        accessor: "areaOfExpertiseId",
        key: "areaOfExpertiseId",
      },
      {
        Header: "Description",
        accessor: "description",
        key: "description",
      },
      {
        Header: "Minimum Age",
        accessor: "ageLowerBound",
        key: "ageLowerBound",
      },
      {
        Header: "Maximum Age",
        accessor: "ageUpperBound",
        key: "ageUpperBound",
      },
      {
        Header: "",
        accessor: "icons",
        key: "icons",
      },
    ],
  []
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
  useTable(
    {
      columns,
      data,
      autoResetSortBy: false,
      autoResetFilters: false,
      initialState: {
        hiddenColumns: ['id', 'areaOfExpertiseId'],
        sortBy: [
            {
                id: 'description',
                desc: false
            }
        ],
      },
      sortTypes: {
        alphanumeric: (row1, row2, columnName) => caseInsensitiveSort({row1, row2, columnName})
      }
    },
    useFilters,
    useSortBy,
  );

  return (
    <Table className="table-sm" striped bordered hover {...getTableProps()}>
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) => {
            const { key, ...restHeaderProps } = (column.id === "icons" || column.id === "ageLowerBound" || column.id === "ageUpperBound") ? column.getHeaderProps() : column.getHeaderProps(column.getSortByToggleProps());
            return (
              <th {...restHeaderProps} key={key}>
                {column.render("Header")}
                {(column.id !== "icons" && column.id !== "ageLowerBound" && column.id !== "ageUpperBound") ? (
                  <>
                  {column.isSorted ? (
                      column.isSortedDesc ? (
                        <FontAwesomeIcon icon={faSortDown} className="ms-2" />
                      ) : (
                        <FontAwesomeIcon icon={faSortUp} className="ms-2" />
                      )
                    ) : (
                      <FontAwesomeIcon icon={faSort} className="ms-2" />
                  )}
                  </>
                ) : <></>
                }
              </th>
            )
          }
          )}
        </tr>
      ))}
    </thead>
    <tbody {...getTableBodyProps()}>
      {
      error ? (<tr><td colSpan={4}>Something went wrong; please reload the page...</td></tr>) : ( 
        !isLoaded ? (<tr><td colSpan={4}>Loading...</td></tr>) : (
          rows.map((row) => {
          prepareRow(row);
          const { key, ...restRowProps } = row.getRowProps();
          return (
            <tr {...restRowProps} key={key}>
              <ProviderAreaOfExpertise providerId={providerId} id={row.values.id} key={row.values.id} areaOfExpertiseId={row.values.areaOfExpertiseId} 
              description={row.values.description ? row.values.description : ""} ageLowerBound={row.values.ageLowerBound ? row.values.ageLowerBound : ""} 
              ageUpperBound={row.values.ageUpperBound ? row.values.ageUpperBound : ""} refreshList={refreshList} canEdit={canEdit}/>
            </tr>
          );
        })))
      }
      {
      addingNew ?
        <tr><ProviderAreaOfExpertise providerId={providerId} key={0} startInEditMode={true} areaOfExpertiseId={0} description={""} ageLowerBound={providerAgeLowerBound ? providerAgeLowerBound : ""} ageUpperBound={providerAgeUpperBound ? providerAgeUpperBound : ""} onCancelEdit={onCancelAddNew} canEdit={canEdit} refreshList={refreshList}/></tr>
      : <></>
      }
    </tbody>
  </Table>
  )
}

const AreasOfExpertise = ({providerId, canEdit}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [ageLowerBound, setAgeLowerBound] = useState("");
  const [ageUpperBound, setAgeUpperBound] = useState("");
  const [addingNew, setAddingNew] = useState(false);
  const [refreshTable, setRefreshTable] = useState(0); // Needed to force table re-render when server sends back new data as a result of provider level range change

  useEffect(() => {
    refreshList();
  }, [providerId])

  function refreshList()
  {
    setAddingNew(false);
    authenticatedFetch({
      path: "areaofexpertise/provider/" + providerId,
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result.areasOfExpertise);
        setAgeLowerBound(result.ageLowerBound);
        setAgeUpperBound(result.ageUpperBound);
        setRefreshTable(refreshTable + 1);
      },
      errorHandler: function() {
        setIsLoaded(true);
        setError(true);
      }
    });
  }

  const handleAddNewClicked = (e) => {
    e.preventDefault();
  
    setAddingNew(true);
  }

  const onCancelAddNew = () => {
    setAddingNew(false);
  }

  var list = [];
  if (isLoaded)
  {
    list = data.map((item, i) => {
      return {key: item.id, id: item.id, areaOfExpertiseId: item.areaOfExpertiseId, description: item.description, ageLowerBound: item.ageLowerBound, ageUpperBound: item.ageUpperBound};
    }, this);
  }

  return (
    <Card>
      <Card.Header style={{marginBottom: '-25px'}}>
        <Card.Title>Areas of Expertise<br />
          <span style={{fontSize: '0.8em', fontWeight: "normal"}}>(Leave age ranges blank for all ages / no bounds)</span>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <ProviderAreasOfExpertiseAgeRangeTable providerId={providerId} list={list} ageLowerBound={ageLowerBound ? ageLowerBound : ""} ageUpperBound={ageUpperBound ? ageUpperBound : ""} isLoaded={isLoaded} refreshList={refreshList} canEdit={canEdit}/>
        <br />
        <AreasOfExpertiseTable key={refreshTable} list={list} addingNew={addingNew} providerAgeLowerBound={ageLowerBound} providerAgeUpperBound={ageUpperBound} onCancelAddNew={onCancelAddNew} providerId={providerId} error={error} isLoaded={isLoaded} canEdit={canEdit} refreshList={refreshList}/>
        {canEdit?
          <span className="float-end" style={{marginTop: '6px'}}>
            <Button size="sm" variant="primary" className="float-end" onClick={(e) => {handleAddNewClicked(e)}}>+ Add New Area of Expertise</Button>
          </span>
          : <></>
        }
      </Card.Body>
    </Card>
  )
}

export default AreasOfExpertise;
